import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "../node_modules/popper.js/dist/popper.js";
import "../node_modules/bootstrap-vue/node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap-vue/node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import "../src/assets/css/site.css";
import $ from "jquery";
import { store } from "@/store/store.js";
import vClickOutsideUmd from "click-outside-vue3";

var healthCheckUrl = process.env.VUE_APP_ROOT_URL + "healthcheck"; 
var loginUrl = process.env.VUE_APP_ROOT_API_URL + "Auth/GetCurrentLoginStatus";

//********************************************IFF THE STORE VALUE DISABLEALLCONSOLELOGSGLOBALLY IS TRUE, DISABLE CONSOLE LOGGING IN ENTIRE APPLICATION */
if(store.disableAllConsoleLogsGlobally){
  console.log = function(){};
}

//*******************************************PERFORM AN AJAX GET TO THE HEALTH CHECK ENDPOINT, TIMEOUT AUTOMATICALLY AFTER 3 SECONDS
//Both ajax calls follow the pattern: initiate, done (on success), fail (on error), and always (after completion regardless of status)
// console.log("starting health check on server");
var healthCheckGet = $.ajax({
    method: "GET",
    contentType: "application/json; charset=utf-8",
    url: healthCheckUrl,
    timeout: 3000,
});

//*******************************************WHEN THE HEALTH CHECK IS SUCCESSFUL, INITIATE A LOGIN STATUS CHECK ON THE SERVER
healthCheckGet.done(function(){
  //console.log("health check success (done)");
  GetLoginStatusServer();
});

//*******************************************IF THE HEALTH CHECK FAILS, SET HEALTHY TO FALSE IN THE STORE
healthCheckGet.fail(function(){

  //console.log("Health Check Failed (fail)", errorThrown);
  store.backendIsHealthy = false;
})

//*******************************************WHEN THE HEALTH CHECK IS COMPLETE (REGARDLESS OF ERRORS)
healthCheckGet.always(function(result){
  store.healthStatus = {statusText: result, healthyYN: store.backendIsHealthy};
  //console.log("health check complete (always) status: ", result, store.healthStatus);
  
  //MOUNT THE APP HERE ONLY IF THE HEALTH CHECK FAILS (OTHERWISE, MOUNT IT AFTER THE LOGIN CHECK)
  if(! store.backendIsHealthy){
    MountVueApp();
  }
});

//**********************ONLY INITIATED UPON A SUCCESSFUL HEALTH CHECK ****************************************************************/
//*******************************************PERFORM AN AJAX GET TO CHECK THE CURRENT LOGIN STATUS OF THE USER
//same pattern as before: initiate, done, fail, always
function GetLoginStatusServer(){
  var loginCheckGet = $.ajax({
      method: "GET",
      url: loginUrl,
      xhrFields: {
        withCredentials: true,
    },
  });
  
  //*******************************************IFF THE LOGIN CHECK COMPLETES SUCCESSFULLY, SET THE USER INFO IN THE STORE, AND LOGGED IN TO TRUE
  loginCheckGet.done(function(result){
    //console.log("login check successful (done): ",result);
    if(result.loggedIn){
      
      store.authenticatedUser = result.userProfileData;
      store.loggedIn = true;
      //console.log("setting authenticated user object: ", store.authenticatedUser);
    }
  });
  
  //*******************************************IFF THERE IS AN ERROR LOG IT
  loginCheckGet.fail(function(){
    //console.log("loginCheckError",errorThrown);
  });
  
  //*******************************************AFTER THE LOGIN CHECK IS COMPLETE (REGARDLESS OF SUCCESS), MOUNT THE APP
  loginCheckGet.always(function(result){
    result;

    //console.log("login check complete (always). ")
    store.healthStatus = {statusText: result.statusText, healthyYN: store.backendIsHealthy};
    MountVueApp();
  });

  return loginCheckGet;
}


//*******************************************MOUNT THE VUE APPLICATION
//CALLED ON A FAILED HEALTH CHECK, OR AFTER A SUCCESFUL HEALTH CHECK AND A COMPLETE LOGIN CHECK
function MountVueApp(){
  if(!store.appIsMounted){
    // console.log("mounting app");
    const app = createApp(App); 
    app.use(router);
    app.use(vClickOutsideUmd); 
    app.mount("#app");
    
    store.appIsMounted = true; 
  }
}

